import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: (props) => ({
    color: props.textColor || '#8898aa',
    backgroundColor: props.bgColor || '#f8f9fe',
    padding: props.noPadding ? '0' : '0 15px',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: 'inherit',
    fontFamily: props.farsiDigits ? 'VazirFD' : 'Vazir',
  }),
}));

const QuoteTypography = ({
  children,
  noPadding,
  farsiDigits,
  bgColor,
  ...props
}) => {
  const classes = useStyles({ noPadding, farsiDigits, bgColor, ...props });

  return (
    <Typography {...props} className={classes.root}>
      {children}
    </Typography>
  );
};

export default QuoteTypography;
